module.exports = __webpack_public_path__ + "static/img/logo.2120efde.png";